import React from 'react';
import { Invoice } from '../../Invoices.types';
import { InvoiceListItem } from '../InvoiceListItem';
import * as S from './InvoicesList.styles';

interface InvoicesListProps {
  invoices: Invoice[];
  onShowDetails: (invoice: Invoice) => void;
  loadMoreSkeleton?: React.ReactNode;
}

export function InvoicesList({
  invoices,
  onShowDetails,
  loadMoreSkeleton,
}: InvoicesListProps) {
  return (
    <S.Container>
      {invoices.map(invoice => (
        <InvoiceListItem
          key={invoice.id}
          invoice={invoice}
          onShowDetails={onShowDetails}
        />
      ))}

      {loadMoreSkeleton}
    </S.Container>
  );
}
